const GlobalConfig = {
  /*apiHostname: "https://api.jejakgroup.com",
  publicDashboardHostname: "https://admin.jejakgroup.com",
  assetsHostname: "https://api.jejakgroup.com",*/
  apiHostname: 'https://api.jejakgroup.com',
  publicDashboardHostname: 'https://admin.jejakgroup.com',
  publicHostname: 'http://localhost:5173',
  assetsHostname: 'https://api.jejakgroup.com/storage',
  mapAPIKey: 'AIzaSyD1zku1HyO1m5PDoRRcn24zTGWR6TbaIfw',
  tinymceKey: 'jc7ioz7j4lbup161umtl8bumaimfmu6m1uw7iw4w4ghs8pca',
  version: '3.4.3.0',
  defaultTop: 20,
  allowedFormats: {
    image: ['image/jpg', 'image/jpeg', 'image/png'],
  },
  maxFileSize: {
    image: 2500000,
  },
  mobileAppScheme: 'jejak',
};

export default GlobalConfig;